var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNutrition(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.83416 8.63086C9.2508 8.63086 8.77734 8.15741 8.77734 7.57404V3.87518C8.77734 3.29181 9.2508 2.81836 9.83416 2.81836C10.4175 2.81836 10.891 3.29181 10.891 3.87518V7.57404C10.891 8.15741 10.4175 8.63086 9.83416 8.63086Z",
    fill: "#E9A5F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8537 8.63086C14.2703 8.63086 13.7969 8.15741 13.7969 7.57404V3.87518C13.7969 3.29181 14.2703 2.81836 14.8537 2.81836C15.4371 2.81836 15.9105 3.29181 15.9105 3.87518V7.57404C15.9105 8.15741 15.4371 8.63086 14.8537 8.63086Z",
    fill: "#E9A5F3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8732 8.63086C19.2899 8.63086 18.8164 8.15741 18.8164 7.57404V3.87518C18.8164 3.29181 19.2899 2.81836 19.8732 2.81836C20.4566 2.81836 20.93 3.29181 20.93 3.87518V7.57404C20.93 8.15741 20.4566 8.63086 19.8732 8.63086Z",
    fill: "#E9A5F3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9858 5.19629H7.71875C6.11556 5.19629 4.8125 6.49935 4.8125 8.10254V25.2758C4.8125 26.879 6.11556 28.1821 7.71875 28.1821H21.9858C23.589 28.1821 24.892 26.879 24.892 25.2758V8.10254C24.892 6.49935 23.589 5.19629 21.9858 5.19629ZM10.0966 11.273H15.3807C15.964 11.273 16.4375 11.7464 16.4375 12.3298C16.4375 12.9132 15.964 13.3866 15.3807 13.3866H10.0966C9.51323 13.3866 9.03977 12.9132 9.03977 12.3298C9.03977 11.7464 9.51323 11.273 10.0966 11.273ZM20.6648 21.8412H10.0966C9.51323 21.8412 9.03977 21.3677 9.03977 20.7844C9.03977 20.201 9.51323 19.7275 10.0966 19.7275H20.6648C21.2481 19.7275 21.7216 20.201 21.7216 20.7844C21.7216 21.3677 21.2481 21.8412 20.6648 21.8412ZM20.6648 17.6139H10.0966C9.51323 17.6139 9.03977 17.1404 9.03977 16.5571C9.03977 15.9737 9.51323 15.5003 10.0966 15.5003H20.6648C21.2481 15.5003 21.7216 15.9737 21.7216 16.5571C21.7216 17.1404 21.2481 17.6139 20.6648 17.6139Z",
    fill: "#E9A5F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNutrition);
export default __webpack_public_path__ + "static/media/nutrition.6fc2dffcdf0a621ec4455d3b4b5d8966.svg";
export { ForwardRef as ReactComponent };